export default {
  loading: 'Carregando...'
}
